import { useTranslation } from 'react-i18next';
import { DealBaggage } from 'ts/package/interfaces/BookPackageResponse';
import { FC } from 'react';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface TicketBaggagePopupProps {
  bag: DealBaggage;
}

const TicketBaggagePopup: FC<TicketBaggagePopupProps> = ({ bag }) => {
  const { t } = useTranslation();

  return (
    <div className="ticket-baggage-popup">
      {bag.unitHandbag !== -1 && (
        <div className="mb-5">
          {bag.unitHandbag ? (
            <span className="text-success">
              {t('flight.handbag_included')}
              {!!bag.maxWeightHandbag && (
                <span>
                  {' '}
                  {bag.maxWeightHandbag} {t('kg')}
                </span>
              )}
            </span>
          ) : (
            <span className="color-danger">{t('flight.handbag_excluded')}</span>
          )}
        </div>
      )}
      {bag.unitTrolley !== -1 && (
        <div className="mb-5">
          {bag.unitTrolley ? (
            <span className="text-success">
              {t('flight.trolley_included')}
              {!!bag.maxWeightTrolley && (
                <span>
                  {' '}
                  {bag.maxWeightTrolley} {t('kg')}
                </span>
              )}
            </span>
          ) : (
            <span className="color-danger">{t('flight.trolley_excluded')}</span>
          )}
        </div>
      )}
      {bag.unitBaggage !== -1 && (
        <div className="mb-5">
          {bag.unitBaggage ? (
            <span className="text-success">
              {t('flight.bag_included')}

              {!!bag.maxWeightBaggage && (
                <span>
                  {' '}
                  {bag.maxWeightBaggage} {t('kg')}
                </span>
              )}
            </span>
          ) : (
            <span className="color-danger">{t('flight.bag_excluded')}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(TicketBaggagePopup, 'TicketBaggagePopup');
